import i18next from 'i18next';

function _t_(text: string) {
  return i18next.t(text);
}

export { _t_ };
